import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useWallet } from '../contexts/WalletContext'
import TicketAllPage from './ticket/TicketAllPage'

const TicketPage: React.FC = () => {
  const navigate = useNavigate()
  const { formatCurrency } = useWallet()
  
  // Tab state
  const [activeTab, setActiveTab] = useState('all')
  
  // Mock data for today's betting
  const todayStats = {
    totalAmount: 0.00,
    waitingCount: 0
  }
  
  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <a 
                      href="#"
                      className="txt-link-d"
                      onClick={() => navigate('/dashboard')}
                    >
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าหลัก
                    </a>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 fs-18 t-medium mb-2">
                      <i className="fas fa-clipboard-list me-2"></i>
                      โพยหวย
                    </div>

                    <div className="bdr-5 bgc-4 p-2 mb-2">
                      <div className="row gap-2 mx--1">
                        <div className="col-12 px-1">
                          <div className="text-center">
                            <h6 className="pt-1 text-start fs-18 t-medium">
                              <i className="fas fa-bolt me-2"></i>
                              ยอดแทงวันนี้
                            </h6>

                            <div className="row mx--1">
                              <div className="col-7 col-md-8 px-1">
                                <div className="bgc-7 bdc-4 py-4 px-1 c-dark bdr-5 mt-2">
                                  <h5>ยอดรวม</h5>
                                  <h3 className="t-medium">{formatCurrency(todayStats.totalAmount)}</h3>
                                </div>
                              </div>

                              <div className="col-5 col-md-4 px-1">
                                <div className="bgc-4 bdc-4 py-4 px-1 c-dark bdr-5 mt-2">
                                  <h5>รอผล</h5>
                                  <h3 className="t-medium">{todayStats.waitingCount}</h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <h6 className="t-medium c-red fs-18 mb-2">หวยทั้งหมด</h6>

                      <div className="nav nav-pills nav-pills-ticket1 mx--1 mb-2" role="tablist">
                        <div className={`nav-link col px-1 py-0 ${activeTab === 'all' ? 'active' : ''}`}>
                          <button 
                            className="check-button w-100 bgc-4 c-dark"
                            onClick={() => setActiveTab('all')}
                          >
                            โพยทั้งหมด
                          </button>
                        </div>
                        <div className={`nav-link col px-1 py-0 ${activeTab === 'waiting' ? 'active' : ''}`}>
                          <button 
                            className="check-button w-100 bgc-4 c-dark"
                            onClick={() => setActiveTab('waiting')}
                          >
                            โพยที่รอผล
                          </button>
                        </div>
                        <div className={`nav-link col px-1 py-0 ${activeTab === 'checked' ? 'active' : ''}`}>
                          <button 
                            className="check-button w-100 bgc-4 c-dark"
                            onClick={() => setActiveTab('checked')}
                          >
                            ผลออกแล้ว
                          </button>
                        </div>
                      </div>

                      <div className="tab-content">
                        <div className={`tab-pane fade ${activeTab === 'all' ? 'show active' : ''}`}>
                          {activeTab === 'all' && <TicketAllPage filter="all" />}
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'waiting' ? 'show active' : ''}`}>
                          {activeTab === 'waiting' && <TicketAllPage filter="waiting" />}
                        </div>
                        <div className={`tab-pane fade ${activeTab === 'checked' ? 'show active' : ''}`}>
                          {activeTab === 'checked' && <TicketAllPage filter="checked" />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TicketPage
